// @ts-nocheck

import { createApp, nextTick } from 'vue'
// import { createLocalVue, mount } from '@vue/test-utils'

import App from './App.vue'
import {CmpApi} from '@iabtcf/gpp';
import {TCModel, TCString, GVL} from '@iabtcf/core';


import {getVisitorCountryAndRegion, isGDPRCountry} from './geo'
import {getParameterByName, ampLogInfo, ampLogError, getCookie, setCookie, setCookieWithExpireTime} from './util'

import { UsCaV1 } from '@iabtcf/gpp/encoder/section/UsCaV1.js'; 
import { UsCoV1 } from '@iabtcf/gpp/encoder/section/UsCoV1.js'; 
import { UsCtV1 } from '@iabtcf/gpp/encoder/section/UsCtV1.js'; 
import { UsUtV1 } from '@iabtcf/gpp/encoder/section/UsUtV1.js'; 
import { UsVaV1 } from '@iabtcf/gpp/encoder/section/UsVaV1.js';

import LayerStateCalifornia from './components/LayerStateCalifornia.vue';
import LayerStateColorado from './components/LayerStateColorado.vue';
import LayerStateConnecticut from './components/LayerStateConnecticut.vue';
import LayerStateUtah from './components/LayerStateUtah.vue';
import LayerStateVirginia from './components/LayerStateVirginia.vue';


const CMP_BUILD = 21;
const CMP_ID = 77;
const CMP_VERSION = 4;
const CMP_CONSENTCOOKIE = "euconsent-v2";
const CMP_NONTCFCONSENTCOOKIE = "euconsent-v2-non-tcf";

const CMP_GPP_CONSENTCOOKIE = "amp-gpp-consent-string";

declare const gGDPR_publisherCountryCode: string;

const __gppMountDivID = "__cmp_mount";
let __gppAppInstance = null;

////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
//
//  Establish the CMP mount point and inject privacy links and messages
//


function __injectDOMElements( ) {
  
    let existingMountDiv = document.getElementById(__gppMountDivID);
  
    if ( existingMountDiv ) {
  
    }
    else {
      var elemDiv = document.createElement('div');
      elemDiv.id = __gppMountDivID
      document.body.appendChild(elemDiv);
      }
  
    setTimeout( () => {
  
      let onClickCommand = "window.scroll(0,0);__gppOpenUI()"; // todo: make this a function call to the GPP CMP
  
      let privacyElem = document.getElementById('ampCMP_privacyPolicy');
      if ( privacyElem)
        privacyElem.innerHTML = '<h4>Privacy Consent Management</h4><p>You can resurface the consent management platform that will allow you to edit and change your consent choices by clicking this link: <a href="javascript:void(0);" onclick="'+onClickCommand+'">Manage Your Consent</a></p>';
      
      let footerElem = document.getElementById('ampCMP_footer');
      if ( footerElem) {
        footerElem.innerHTML = '<a class="nav-link" href="javascript:void(0);" onclick="'+onClickCommand+'">Privacy Choices</a>';
      }
        
    }, 500);
  
  }
  
  __injectDOMElements( );

window.__gppOpenUI = function() {
  if ( ! __gppAppInstance ) {
    ampLogInfo( "__gppOpenUI():  __gppAppInstance not initialized" );
  } else {
  __gppAppInstance.openCMP();
  }
}

////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////

//  Get consent strings in and out of the GPP api and updating them in the cookie and
//  local storage locations

function __storeGPPString( encodedString : string ) : void  {
  ampLogInfo( "__storeGPPString() result = " + encodedString)
  cmpApi.setGppString( encodedString );
  setCookie(CMP_GPP_CONSENTCOOKIE, encodedString, 365 );
}

function __getGPPString(  ) : string  {
  return  cmpApi.getGppString( );
}

function __updateGPPCookie( ) : void  {

  //todo: also set this in local storage
  let gppString = __getGPPString();

  console.log( "CMP(): __updateGPPCookie() : " + gppString  ) ;

  setCookie(CMP_GPP_CONSENTCOOKIE, gppString, 365 );

}

function __getGPPCookie(  ) : string  {

  //todo: also get this in local storage

  return getCookie( CMP_GPP_CONSENTCOOKIE );

}

////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////

//  These functions deal with TCF (GDPR) consent strings encoded/decoded by the TCModel class,
//  feeds through to save the encoded consent string in the 'tcfeuv2' GPP section

  function __storeTCString( ) : void {
    
    ampLogInfo( "__storeTCString() : Begins")
    
    //@ts-ignore
    console.log(window.__cmpTCModel);

    // @ts-ignore
    const encodedString = TCString.encode(window.__cmpTCModel);
  
    ampLogInfo( "storeTCString() result = " + encodedString)

    setCookie(CMP_CONSENTCOOKIE, encodedString, 365 );

    setCookie(CMP_NONTCFCONSENTCOOKIE, "", 365 );

    cmpApi.setSectionString( 'tcfeuv2', encodedString);
    cmpApi.fireEvent( "sectionChanged",  'tcfeuv2');
    cmpApi.setSignalStatus( "ready" );
 
    __updateGPPCookie();
  }         

function __storeAcceptAllTCString() {

  console.log( "CMP(): Accept All")

  window.__cmpTCModel.setAll();

  // console.log( "Allowing all purposeLegitimateInterests")

  // for ( let v of [1,2,3,4,5,6,7,8,9,10] ) {
  //   window.__cmpTCModel.purposeLegitimateInterests.set(v);
  // }

  // ampLogInfo( "Allowing all vendorLegitimateInterests")

  // for (var i = 1; i <= 1100; i++) {
  //   window.__cmpTCModel.purposeLegitimateInterests.set(i);
  // }

if ( typeof gGDPR_NonTCFVendors !="undefined" ) {
    gGDPR_NonTCFVendors.forEach(( element:object, index : number, a:Array<object> ) => {
    gGDPR_NonTCFVendors[index].consent = gGDPR_NonTCFVendors[index].modelConsent = true;
    });
  }

  __storeTCString();
}


function __storeRejectAllTCString() {

  ampLogInfo( "Reject All")
    
    // todo: gpp model

    window.__cmpTCModel.unsetAll();  // this is the GDPR flavor

  if ( typeof gGDPR_NonTCFVendors !="undefined" ) {
      gGDPR_NonTCFVendors.forEach(( element:object, index : number, a:Array<object> ) => {
      gGDPR_NonTCFVendors[index].consent = gGDPR_NonTCFVendors[index].modelConsent = false;
      });
    }
    
    __storeTCString();
}


////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
//
// GPP Stub Implementation... iabgpp-es assumes this is available before
// initialization (code from https://github.com/IABTechLab/iabgpp-es/blob/master/modules/stub/src/stub.js)
//

window.__gpp_addFrame = function (n) {
  if (!window.frames[n]) {
    if (document.body) {
      var i = document.createElement("iframe");
      i.style.cssText = "display:none";
      i.name = n;
      document.body.appendChild(i);
    } else {
      window.setTimeout(window.__gpp_addFrame, 10, n);
    }
  }
};
window.__gpp_stub = function () {
  var b = arguments;
  __gpp.queue = __gpp.queue || [];
  __gpp.events = __gpp.events || [];

  if (!b.length || (b.length == 1 && b[0] == "queue")) {
    return __gpp.queue;
  }

  if (b.length == 1 && b[0] == "events") {
    return __gpp.events;
  }

  var cmd = b[0];
  var clb = b.length > 1 ? b[1] : null;
  var par = b.length > 2 ? b[2] : null;
  if (cmd === "ping") {
    clb(
      {
        gppVersion: "1.1", // must be “Version.Subversion”, current: “1.1”
        cmpStatus: "stub", // possible values: stub, loading, loaded, error
        cmpDisplayStatus: "hidden", // possible values: hidden, visible, disabled
        signalStatus: "not ready", // possible values: not ready, ready
        supportedAPIs: [
          "2:tcfeuv2",
          "5:tcfcav1",
          "6:uspv1",
          "7:usnatv1",
          "8:uscav1",
          "9:usvav1",
          "10:uscov1",
          "11:usutv1",
          "12:usctv1",
        ], // list of supported APIs
        cmpId: 0, // IAB assigned CMP ID, may be 0 during stub/loading
        sectionList: [],
        applicableSections: [],
        gppString: "",
        parsedSections: {},
      },
      true
    );
  } else if (cmd === "addEventListener") {
    if (!("lastId" in __gpp)) {
      __gpp.lastId = 0;
    }
    __gpp.lastId++;
    var lnr = __gpp.lastId;
    __gpp.events.push({
      id: lnr,
      callback: clb,
      parameter: par,
    });
    clb(
      {
        eventName: "listenerRegistered",
        listenerId: lnr, // Registered ID of the listener
        data: true, // positive signal
        pingData: {
          gppVersion: "1.1", // must be “Version.Subversion”, current: “1.1”
          cmpStatus: "stub", // possible values: stub, loading, loaded, error
          cmpDisplayStatus: "hidden", // possible values: hidden, visible, disabled
          signalStatus: "not ready", // possible values: not ready, ready
          supportedAPIs: [
            "2:tcfeuv2",
            "5:tcfcav1",
            "6:uspv1",
            "7:usnatv1",
            "8:uscav1",
            "9:usvav1",
            "10:uscov1",
            "11:usutv1",
            "12:usctv1",
          ], // list of supported APIs
          cmpId: 0, // IAB assigned CMP ID, may be 0 during stub/loading
          sectionList: [],
          applicableSections: [],
          gppString: "",
          parsedSections: {},
        },
      },
      true
    );
  } else if (cmd === "removeEventListener") {
    var success = false;
    for (var i = 0; i < __gpp.events.length; i++) {
      if (__gpp.events[i].id == par) {
        __gpp.events.splice(i, 1);
        success = true;
        break;
      }
    }
    clb(
      {
        eventName: "listenerRemoved",
        listenerId: par, // Registered ID of the listener
        data: success, // status info
        pingData: {
          gppVersion: "1.1", // must be “Version.Subversion”, current: “1.1”
          cmpStatus: "stub", // possible values: stub, loading, loaded, error
          cmpDisplayStatus: "hidden", // possible values: hidden, visible, disabled
          signalStatus: "not ready", // possible values: not ready, ready
          supportedAPIs: [
            "2:tcfeuv2",
            "5:tcfcav1",
            "6:uspv1",
            "7:usnatv1",
            "8:uscav1",
            "9:usvav1",
            "10:uscov1",
            "11:usutv1",
            "12:usctv1",
          ], // list of supported APIs
          cmpId: 0, // IAB assigned CMP ID, may be 0 during stub/loading
          sectionList: [],
          applicableSections: [],
          gppString: "",
          parsedSections: {},
        },
      },
      true
    );
  } else if (cmd === "hasSection") {
    clb(false, true);
  } else if (cmd === "getSection" || cmd === "getField") {
    clb(null, true);
  }
  //queue all other commands
  else {
    __gpp.queue.push([].slice.apply(b));
  }
};
window.__gpp_msghandler = function (event) {
  var msgIsString = typeof event.data === "string";
  try {
    var json = msgIsString ? JSON.parse(event.data) : event.data;
  } catch (e) {
    var json = null;
  }
  if (typeof json === "object" && json !== null && "__gppCall" in json) {
    var i = json.__gppCall;
    window.__gpp(
      i.command,
      function (retValue, success) {
        var returnMsg = {
          __gppReturn: {
            returnValue: retValue,
            success: success,
            callId: i.callId,
          },
        };
        event.source.postMessage(msgIsString ? JSON.stringify(returnMsg) : returnMsg, "*");
      },
      "parameter" in i ? i.parameter : null,
      "version" in i ? i.version : "1.1"
    );
  }
};
if (!("__gpp" in window) || typeof window.__gpp !== "function") {
  window.__gpp = window.__gpp_stub;
  window.addEventListener("message", window.__gpp_msghandler, false);
  window.__gpp_addFrame("__gppLocator");
}

////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////

var __gppEventListenerReturn = __gpp('addEventListener', ( event ) => { 
  
  console.log( event )
  if (event.eventName == "sectionChanged") 
    __updateGPPCookie();
});


////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
//
//  Startup
//


// @ts-ignore
declare var gGDPR_NonTCFVendors: object[];  // external variable in site layout file...


ampLogInfo( "AdMetricsPro GPP CMP" + CMP_BUILD)

  GVL.baseUrl = "https://qd.admetricspro.com/js/gpp/vendor-list-v3/";
  GVL.latestFilename = 'vendor-list.json';   

  window.__GVL = new GVL();
  window.__cmpTCModel = new TCModel( window.__GVL );
  
  window.__cmpTCModel.cmpId = CMP_ID;
  window.__cmpTCModel.cmpVersion = CMP_VERSION;
  window.__cmpTCModel.consentScreen = 1;
  window.__cmpTCModel.isServiceSpecific = true;
  window.__cmpTCModel.publisherCountryCode = typeof gGDPR_publisherCountryCode != 'undefined' ? gGDPR_publisherCountryCode : 'US';

  if ( typeof gGDPR_NonTCFVendors == 'undefined' ) {
    gGDPR_NonTCFVendors = [];
  }

  console.log(" >>>>>>>> Before CmpApi <<<<<<<<<<<<<<<<<<<");

  var gppResponseFunc = function( tcData, success ) {
    if ( typeof success != "undefined" && success == false ) {      // gpp 1.0 does not have success in callback
        console.log( "CMP error response" )
    } else {
      console.log( tcData );
    }
    }


  console.log( __gpp( 'ping', 2, gppResponseFunc ) );
  console.log(" >>>>>>>> SETTING CmpApi <<<<<<<<<<<<<<<<<<<");

  const cmpApi = new CmpApi(CMP_ID, CMP_BUILD); 

  console.log(" >>>>>>>> After CmpApi <<<<<<<<<<<<<<<<<<<");
  console.log( __gpp( 'ping', 2, gppResponseFunc ) );

  console.log(" >>>>>>>>  >>>>><<<<<   <<<<<<<<<<<<<<<<<");

  // window.__gpp = cmpApi;

  let callback = function( status: boolean, country : string, region : string ) {
      if ( ! status ) {
        ampLogError( "Error getting visitor country and region");
        return;
      } 

      let consentString = __getGPPCookie( );

      let clearConsent = getParameterByName("ampGPPClear");

      if ( clearConsent ) {
        ampLogInfo( "ampGPPClear present, clearing consent" );
        consentString = undefined;
      }

      if (consentString ) {
        ampLogInfo( "Initializing with existing GPP consent string: " + consentString);
        cmpApi.setGppString(consentString);
      }
      else {
        ampLogInfo( "No exisiting consent found, clearing GPP consent string");
        cmpApi.clear();
      }

      let forcedCountryCode = getParameterByName("ampGPPCMPCC");
      let forcedRegionCode = getParameterByName("ampGPPCMPRegion");

      if ( forcedCountryCode )
        country = forcedCountryCode
      
      if ( forcedRegionCode )
        region = forcedRegionCode
        
     ampLogInfo( "Visitor country: " + country + " region: " + region );

      const gdprApplies = isGDPRCountry( country  );
      const isUSA = country == "US";

      ampLogInfo( "GDPR " + ( gdprApplies ? "applies." : "does not apply." ) );

      nextTick( () => {
        // console.log( "__cmpOpenUI():  nextTick" );

        let initalLayer = "";
        let openCMP = false;

        if (gdprApplies) {
          initalLayer = "layerOne";
          if ( cmpApi.hasSection( 'tcfeuv2') ) {
            ampLogInfo( "GDPR TCF EU V2.x Privacy Data Present, initializing without opening CMP UI");
            cmpApi.setSignalStatus( "ready" );
            openCMP = false;
          } else {

            // leave signalStatus as 'not ready' until user interaction is complete

            openCMP = true;
          }       


        } else {
          function test( regiontoTest, stateName, cmpSection, cmpDisplayLayer, grantConsentFunc ) {
            if ( isUSA && (region == regiontoTest) ) {
              initalLayer = cmpDisplayLayer;
              if ( cmpApi.hasSection( cmpSection ) ) {
                ampLogInfo( stateName + " Privacy Data Present, initializing from stored consent");
                cmpApi.setSignalStatus( "ready" );
                openCMP = false;
              } else {
                ampLogInfo( stateName + " Privacy Data Not Present, initializing with default consent");
                grantConsentFunc( true );
                cmpApi.setSignalStatus( "ready" );
                openCMP = false;
              }       
            }
          }
  
          test( "CA", "California", UsCaV1.NAME, "layerStateCalifornia", LayerStateCalifornia.consentToAll );
          test( "CO", "Colorado", UsCoV1.NAME, "layerStateColorado", LayerStateColorado.consentToAll );
          test( "CT", "Connecticut", UsCtV1.NAME, "layerStateConnecticut", LayerStateConnecticut.consentToAll );
          test( "UT", "Utah", UsUtV1.NAME, "layerStateUtah", LayerStateUtah.consentToAll );
          test( "VA", "Virginia", UsVaV1.NAME, "layerStateVirginia", LayerStateVirginia.consentToAll );
  
          }

        if ( initalLayer ) {
          let props =  {
            initialVisible: true,
            reopenLayer:initalLayer,
            initialLayer:openCMP ? initalLayer : "close",
            cmpApi: cmpApi,
            storeTCString: __storeTCString,
            storeAcceptAllTCString: __storeAcceptAllTCString,
            storeRejectAllTCString: __storeRejectAllTCString,
          }

          __gppAppInstance = createApp( App, props ).mount('#' + __gppMountDivID);


        } 
      } );

  }

  window.__cmpTCModel.gvl.readyPromise.then( () => { 
    // @ts-ignore
    ampLogInfo( "GVL version is " + window.__GVL.vendorListVersion)
    
    cmpApi.setCmpStatus( "loaded" );

    // @ts-ignore
    const encodedString = TCString.encode(window.__cmpTCModel);
    ampLogInfo( encodedString);

    getVisitorCountryAndRegion( callback );

} );



    // cmpApi.setGppString(gppString);


//     if ( ! cookie ) {
//       console.log( "CMP: GDPR applies and no existing consent")
//       targetLayer = "layerOne";
//     } else if ( needNewConsent ) {
//       console.log( "CMP: consent out dated, requesting new consent")
//       targetLayer = "layerOne";
//     }
//     else     
//       console.log( "CMP: GDPR applies, using existing consent")
//   }
//   else
//   {
//     console.log( "CMP: GDPR does not apply ")
//     cmpApi.update(null);
//   }





//  https://github.com/IABTechLab/iabgpp-es

// http://localhost:8080/?ampGPPCMPCC=DE    for GDPR testing (check port)

// http://localhost:8080/?ampGPPCMPCC=US&ampGPPCMPRegion=CO    for CO testing (check port)

// https://www.dadsworksheets.com/test/gpp.html?ampGPPClear=1&ampGPPCMPCC=US&ampGPPCMPRegion=CO

// http://localhost:8077/?ampGPPClear=1&ampGPPCMPCC=FR

